import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../modules/authentication/services/auth.service";
import { from, switchMap } from "rxjs";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return from(authService.refreshFirebaseToken()).pipe(
    switchMap((token: string) => {
      const newRequest = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });

      return next(newRequest);
    })
  );
 };